import { Link } from '@backstage/core-components';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import { useStyles } from './externalLink.style';

type ExternalLinkProps = {
  to: string;
  children: React.ReactNode;
};

function ExternalLink({ to, children }: ExternalLinkProps) {
  const { cx, classes } = useStyles();

  return (
    <Link to={to} target="_blank" rel="noopener noreferrer">
      {children}
      <OpenInNewIcon className={cx(classes.icon)} />
    </Link>
  );
}

export { ExternalLink };
